var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.$route.meta.customPage
    ? _c("div", [_c("router-view")], 1)
    : _c(
        "v-app",
        {
          attrs: {
            id: "amui-app"
          }
        },
        [
          _c("router-view"),
          _c("clear-cache-modal"),
          _c("notifications"),
          _vm.isAuthenticated && _vm.idleEnabled ? _c("idle-ping") : _vm._e(),
          _vm.isAuthenticated ? _c("app-survey") : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }